module.exports = __webpack_public_path__ + "media/images/country_flags/ai-09a78767723deb4fec92bc3401d9c563.png";